"use client";

import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useVersion } from "modules/version/useVersion";
import { deploymentCommitLabel } from "utils/deployment-id";

type WebDeployment = {
  deploymentId: string;
};

async function getWebDeployment(): Promise<WebDeployment> {
  const response = await fetch("/api/deployment", {
    cache: "no-store",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Deployment request failed with ${response.status}`);
  }
  const data: unknown = await response.json();
  if (
    typeof data !== "object" ||
    data === null ||
    typeof (data as Partial<WebDeployment>).deploymentId !== "string"
  ) {
    throw new Error("Deployment response is missing deploymentId");
  }
  return data as WebDeployment;
}

export const VersionTagRibbon = () => {
  const apiVersion = useVersion();
  const webDeployment = useQuery({
    queryKey: ["webDeployment"],
    queryFn: getWebDeployment,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  const parts = [
    apiVersion.isSuccess ? apiVersion.data.tag : null,
    webDeployment.isSuccess
      ? deploymentCommitLabel(webDeployment.data.deploymentId)
      : null,
  ].filter(Boolean);

  if (parts.length === 0) {
    return <></>;
  }

  return (
    <span className="text-secondary text-center text-xs">
      {parts.join(" · ")}
    </span>
  );
};
